import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsSettingsWidget" */ './SportsSettingsWidget'),
  modules: ['./SportsSettingsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
